/**
 * Legacy LockApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.lockApi`) keep resolving.
 *
 * The actual LockApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/lock/lock-api.service.ts
 */
angular.module("acme.common.service.lockApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
